var exports = {
  "jD": "x31de4314--ae796d--cont",
  "eA": "x31de4314--ae796d--cont--flexible",
  "eu": "x31de4314--ae796d--cont--empty",
  "Li": "x31de4314--ae796d--cont--with-thumbnails",
  "cs": "x31de4314--ae796d--cont-newbuilding",
};

module.exports = exports;
